import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { Fragment } from "react";
import FeedbackRowViewModel from "../ViewModels/FeedbackRowViewModel";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TablePagination from "@mui/material/TablePagination";

const styles = {
    tableCell: {
        padding: '4px 12px 4px 12px',
    },
}

interface IFeedbackTableProps {
    view: string;
    feedbackRows: FeedbackRowViewModel[];
    handleFeedbackOpen: (callRefId: string, completeId: number, systemId: string) => void;
    handleChangePage: (event: unknown, newPage: number) => void;
    handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
    page: number;
    rowsPerPage: number;
    count: number;
}

export default function FeedbackTable(props: IFeedbackTableProps) {

    const finalisedState = (feedbackStatus: string) => {
        return feedbackStatus === 'Feedback Accepted'
            || feedbackStatus === 'Challenge Rejected'
            || feedbackStatus === 'Challenge Upheld'
    }

    return (
        <Fragment>
            <Table >
                <TableHead>
                    <TableRow>
                        {
                            props.view !== 'Agent' &&
                            <TableCell sx={styles.tableCell}>Agent</TableCell>
                        }
                        <TableCell sx={styles.tableCell}>Monitor</TableCell>
                        <TableCell sx={styles.tableCell}>Team Leader</TableCell>
                        <TableCell sx={styles.tableCell}>Client</TableCell>
                        <TableCell sx={styles.tableCell}>Channel</TableCell>
                        <TableCell sx={styles.tableCell}>Scorecard Name</TableCell>
                        <TableCell sx={styles.tableCell}>Date Completed</TableCell>
                        <TableCell sx={styles.tableCell}>QA Result</TableCell>
                        <TableCell sx={styles.tableCell}>QA SubResult</TableCell>
                        <TableCell sx={styles.tableCell}>Status</TableCell>
                        <TableCell sx={styles.tableCell}>Date Released</TableCell>
                        <TableCell sx={styles.tableCell}>Date Agent Responded</TableCell>
                        <TableCell sx={styles.tableCell}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.feedbackRows.length <= 0 &&
                        <TableRow>
                            <TableCell align="center" colSpan={12} sx={styles.tableCell}>No records found</TableCell>
                        </TableRow>
                    }
                    {props.feedbackRows.length > 0 && props.feedbackRows.map((row, index) =>
                        <TableRow key={index}>
                            {
                                props.view !== 'Agent' &&
                                <TableCell sx={styles.tableCell}>{row.agentName}</TableCell>
                            }
                            <TableCell sx={styles.tableCell}>{row.monitorName}</TableCell>
                            <TableCell sx={styles.tableCell}>{row.teamLeader}</TableCell>
                            <TableCell sx={styles.tableCell}>{row.client}</TableCell>
                            <TableCell sx={styles.tableCell}>{row.channel}</TableCell>
                            <TableCell sx={styles.tableCell}>{row.scorecardName}</TableCell>
                            <TableCell sx={styles.tableCell}>{row.dateMonitored}</TableCell>
                            <TableCell sx={styles.tableCell}>{row.result}</TableCell>
                            <TableCell sx={styles.tableCell}>{row.scorecardOutcome}</TableCell>
                            <TableCell sx={styles.tableCell}>{row.status?.toString() ?? ''}</TableCell>
                            <TableCell sx={styles.tableCell}>{row.dateReleased}</TableCell>
                            <TableCell sx={styles.tableCell}>{row.dateAgentResponded}</TableCell>
                            < TableCell align="right" sx={{ width: '210px', padding: '4px 12px 4px 12px' }}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={() => { props.handleFeedbackOpen(row.callRefId, row.completeId, row.systemId) }}
                                    disabled={props.view === "Agent" && finalisedState(row.status)}
                                >
                                    View
                                </Button>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
            <Grid container justifyContent="flex-end">
                <Grid>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={props.count}
                        rowsPerPage={props.rowsPerPage}
                        page={props.page}
                        onPageChange={props.handleChangePage}
                        onRowsPerPageChange={props.handleChangeRowsPerPage}
                    />
                </Grid>
            </Grid>
        </Fragment >
    );
}